import { z } from "zod";

// ScrapingBee proxy geolocation codes (ISO 3166-1 alpha-2). A website's country
// decides which country's residential IP its pages are rendered from, so the
// capture matches what a local visitor sees.
// biome-ignore format: a grid keeps the provider's full list readable and short
export const SCRAPE_COUNTRY_CODES = [
  "af", "al", "dz", "as", "ad", "ao", "ai", "aq", "ag", "ar", "am", "aw", "au",
  "at", "az", "bs", "bh", "bd", "bb", "by", "be", "bz", "bj", "bm", "bt", "bo",
  "ba", "bw", "bv", "br", "io", "vg", "bn", "bg", "bf", "bi", "kh", "cm", "ca",
  "cv", "ky", "cf", "td", "cl", "cn", "cx", "cc", "co", "km", "cg", "ck", "cr",
  "hr", "cu", "cy", "cz", "ci", "dk", "dj", "dm", "do", "ec", "eg", "sv", "gq",
  "er", "ee", "et", "fk", "fo", "fj", "fi", "fr", "gf", "pf", "tf", "ga", "gm",
  "ge", "de", "gh", "gi", "gr", "gl", "gd", "gp", "gu", "gt", "gn", "gw", "gy",
  "ht", "hm", "hn", "hk", "hu", "is", "in", "id", "iq", "ie", "ir", "il", "it",
  "jm", "jp", "jo", "kz", "ke", "ki", "kp", "kr", "kw", "kg", "la", "lv", "lb",
  "ls", "lr", "ly", "li", "lt", "lu", "mo", "mg", "mw", "my", "mv", "ml", "mt",
  "mh", "mq", "mr", "mu", "yt", "mx", "fm", "md", "mc", "mn", "ms", "ma", "mz",
  "mm", "na", "nr", "np", "nl", "nc", "nz", "ni", "ne", "ng", "nu", "nf", "mp",
  "no", "om", "pk", "pw", "pa", "pg", "py", "pe", "ph", "pn", "pl", "pt", "pr",
  "qa", "ro", "ru", "rw", "re", "lc", "ws", "sm", "st", "sa", "sn", "sc", "sl",
  "sg", "sk", "si", "sb", "so", "za", "gs", "es", "lk", "sh", "kn", "pm", "vc",
  "sd", "sr", "sj", "sz", "se", "ch", "sy", "tw", "tj", "tz", "th", "tg", "tk",
  "to", "tt", "tn", "tr", "tm", "tc", "tv", "ug", "ua", "ae", "gb", "um", "vi",
  "us", "uy", "uz", "vu", "va", "ve", "vn", "wf", "eh", "ye", "zm", "zw",
] as const;
export const ScrapeCountryCodeSchema = z.enum(SCRAPE_COUNTRY_CODES);
export type ScrapeCountryCode = z.infer<typeof ScrapeCountryCodeSchema>;

export const DEFAULT_SCRAPE_COUNTRY_CODE: ScrapeCountryCode = "au";
